// src/components/Billing/Styles/StripeElementWrapper.Style.js
// @flow

/**
 * Replaces the old `(theme) => ({ ... })` function from `withStyles`.
 * Each key is now a function `(theme) => ({ ... })`.
 */
const stripeElementWrapperStyles = {
  newFormElt: (theme) => ({
    '& input, & iframe *, & iframe input': {
      fontFamily: 'Product Sans'
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: 'black'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      opacity: 0.75
    }
  }),

  errorLabel: (theme) => ({
    // old code had `marginLeft: theme.spacing(1),`
    color: '#f44336 !important'
  }),

  // If `signupStyles` had something like `newInputForm`, we define a placeholder here so you can merge them.
  newInputForm: (theme) => ({
    // empty or local modifications if needed
  })
};

export default stripeElementWrapperStyles;